import React from "react";
import { Link } from "react-router-dom";
import { Inbox, Loader2, AlertTriangle } from "lucide-react";

export const EmptyState = ({ icon: Icon = Inbox, title, desc, cta, to, testId = "empty-state" }) => (
  <div data-testid={testId} className="py-12 px-4 text-center">
    <div className="w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center"
         style={{ background: "rgba(59,130,246,0.08)", border: "1px solid rgba(59,130,246,0.2)" }}>
      <Icon size={18} style={{ color: "var(--brand)" }}/>
    </div>
    <div className="text-sm font-medium" style={{ color: "var(--text)" }}>{title}</div>
    {desc && <div className="text-xs mt-1.5 max-w-sm mx-auto" style={{ color: "var(--text-dim)" }}>{desc}</div>}
    {cta && to && (
      <Link to={to} data-testid={`${testId}-cta`} className="btn-primary inline-flex mt-5 px-4 py-2 rounded-full text-xs">{cta}</Link>
    )}
  </div>
);

export const LoadingState = ({ label = "Loading…" }) => (
  <div data-testid="loading-state" className="py-12 flex items-center justify-center gap-2 text-sm" style={{ color: "var(--text-dim)" }}>
    <Loader2 size={15} className="animate-spin"/> {label}
  </div>
);

export const ErrorState = ({ message, onRetry }) => (
  <div data-testid="error-state" className="py-10 text-center text-sm">
    <AlertTriangle size={18} className="mx-auto mb-2 text-amber-500"/>
    <div style={{ color: "var(--text-muted)" }}>{message}</div>
    {onRetry && <button data-testid="error-retry-btn" onClick={onRetry} className="btn-ghost mt-3 px-3 py-1.5 rounded-full text-xs">Try again</button>}
  </div>
);

export default EmptyState;
